import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { dispatchStorePage } from '@/store/dispatches'
import { OptionInterface, FilterInterface } from '@/interfaces/page'

@Component
export default class ListPage extends Vue {
  options: {
    [key: string]: any;
  } = {}

  filter: {
    [key: string]: any;
  } = {}

  windowSize = {
    w: 0,
    h: 0
  }

  actionsHeight = 51

  async restorePage (cache: string) {
    if (!cache) {
      return
    }

    const { options, filter } = JSON.parse(cache)
    this.options = options
    this.filter = filter
  }

  async storePage () {
    const { options, filter } = this
    dispatchStorePage({
      page: this.$route.name ?? '',
      options: options as OptionInterface,
      filter: filter as FilterInterface
    })
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
    const actionDom = this.$refs.actions as Vue & {
      clientHeight: number;
    }
    this.actionsHeight = actionDom.clientHeight
  }
}
